export default __webpack_public_path__ + "static/media/logo-bg.5ba7da12.png";